<div>
  <h2 data-testid="split-rate-details-title" class="page-details-title-style">Split Rate for Agent {{agentId}}</h2>
</div>

<split-rate-info [data]="agentId"></split-rate-info>
